import React, { useState, memo, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";
import Num2persian from "num2persian";
import { toast } from "react-toastify";

import { persianArabicToEnglish } from "../../../Utils/UnicodeConvert";
import SpinnerButton from "../../../Components/SpinnerButton";
import WalletSwitch from "../../../Components/WalletSwitch";
import {
  cardNumberSeparator,
  priceDigitSeperator,
} from "../../../Utils/Helpers";
import ModalResult from "../../../Components/ModalResult";
import tickIcon from "../../../Assets/Images/tick.svg";
import Loading from "../../../Components/Loading";
import Logo from "../../../Components/Logo";
import "./styles.css";
import ModalOtp from "../../../Components/ModalOtp";
import {
  getSoftPosOtp,
  softPosPaymentWithTransactionId,
} from "../../../Actions/DaapAppSoftPosActions/SoftPosActions";
import { useMask } from "@react-input/mask";

const Screen = (props) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [modalResult, setModalResult] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [modalButtonLoading, setModalButtonLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState({});
  const [credit, setCredit] = useState("");
  const [result, setResult] = useState({});
  const [modalOtp, setModalOtp] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const history = useHistory();
  const { cardNo, business_id } = props?.location?.state?.result || {};
  const { clubId, transactionId, business } = props?.location?.state || {};
  const [timer, setTimer] = useState(0);
  let interval;

  console.log(selectedOptions, "saasdasd");
  const inputRef = useMask({
    mask: "______",
    replacement: { _: /\d/ },
  });

  useEffect(() => {
    const data = props.location.state.result;
    setDetail(data);
  }, []);

  useEffect(() => {
    interval = setInterval(() => {
      if (timer === 0) {
        return;
      }
      setTimer(timer - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  const onClickGetOtp = () => {
    setOtpLoading(true);
    getSoftPosOtp({ transaction_id: transactionId }).finally(() => {
      setTimer(60);
      setOtpLoading(false);
    });
  };

  const onClickPayment = () => {
    const confirm = window.confirm("آیا از پرداخت خود مطمئن هستید؟");
    if (confirm) {
      setModalButtonLoading(true);
      const params = {
        transaction_id: props?.location?.state?.transactionId,
        club_id: clubId,
        amount: detail?.total_amount,
        payment_using_wallet_balance: true,
        ewallets: selectedOptions,
        otp_code: otpCode,
      };
      softPosPaymentWithTransactionId(params)
        .then((data) => {
          history.push({
            pathname: "/result",
            state: {
              transactionId,
              isSoftPos: true,
            },
          });
        })
        .catch((err) => {
          setResult(err);
          setModalResult(true);
        })
        .finally((_) => {
          setModalButtonLoading(false);
        });
    }
  };

  return (
    <div className="payment">
      {!loading ? (
        <Fragment>
          <Logo />
          <div className="d-flex justify-content-center mt-3">
            <h6>
              خرید از فروشگاه:{" "}
              <span className="payment-section-form-credit_blue">
                {business?.shop_name}
              </span>
            </h6>
          </div>
          <div className="sign-in-form">
            <p className="sign-in-form-p">شماره کارت</p>
            <div className="payment-section-form-amount position-relative">
              <div className="payment-section-form-amount-input">
                {cardNumberSeparator(cardNo)}
              </div>
            </div>
            <p className="sign-in-form-p mt-4">مبلغ قابل پرداخت (تومان)</p>
            <div className="payment-section-form-amount position-relative">
              <div className="payment-section-form-amount-input">
                {priceDigitSeperator(detail?.total_amount)}
              </div>
            </div>
            <small className="text-left mt-1">
              {Num2persian(
                Math.floor(persianArabicToEnglish(detail?.total_amount)) * 10,
              )}{" "}
              ریال
            </small>
            {/*<div className="payment-section-form-credit mb-2">*/}
            {/*  <img className="tickIcon" src={tickIcon} />*/}
            {/*  <span className="payment-section-form-credit_text">*/}
            {/*    موجودی کیف پول شما:*/}
            {/*    <span className="payment-form-credit_blue">*/}
            {/*      {priceDigitSeperator(credit) || "0"} تومان*/}
            {/*    </span>*/}
            {/*  </span>*/}
            {/*</div>*/}
            <WalletSwitch
              isSoftpos
              cardNo={cardNo}
              transactionId={transactionId}
              businessId={business_id}
              selectedPaymentOptions={(options) => {
                setSelectedOptions(options);
              }}
              credit={(value) => setCredit(value)}
            />
            {/*<Amount*/}
            {/*  amount_of_transaction={detail?.total_amount}*/}
            {/*  eWallets={selectedOptions}*/}
            {/*/>*/}
            <div className="d-flex align-items-center mt-4">
              <input
                className="sign-in-form-input "
                onChange={(e) => setOtpCode(e.target.value)}
                maxLength={6}
                ref={inputRef}
              />
              <SpinnerButton
                className="otp-button"
                onClick={otpLoading ? () => {} : onClickGetOtp}
                text={timer ? timer : "دریافت رمز"}
                disabled={otpLoading || timer !== 0 || !selectedOptions.length}
              />
            </div>

            <SpinnerButton
              className="sign-in-form-btn mt-5"
              onClick={onClickPayment}
              text="پرداخت"
              loading={btnLoading}
              disabled={!otpCode}
            />
          </div>
        </Fragment>
      ) : (
        <Loading />
      )}
      {/*<ModalOtp*/}
      {/*  show={modalOtp}*/}
      {/*  onChange={(value) => setOtpCode(value)}*/}
      {/*  closeModal={() => setModalOtp(false)}*/}
      {/*  onClickSubmitOtp={onClickPayment}*/}
      {/*  onclickGetAgainCode={onClickGetOtp}*/}
      {/*  loading={modalButtonLoading}*/}
      {/*  isSoftPos*/}
      {/*/>*/}
      <ModalResult
        show={modalResult}
        onClose={() => setModalResult(false)}
        result={result}
      />
    </div>
  );
};
export default memo(Screen);
